import React from 'react';

const TableCober = ({ array = [] }) => {
    return (
        <table className="table-vsc table-cober-vsc">
            <thead className="table-head-vsc">
                <th className="w60">Coberturas</th>
                <th className="w30"> Monto a Indemnizar </th>
            </thead>
            <tbody className="table-body-vsc">
                {array.map(item => (
                    <tr>
                        <td>{item.nombre}</td>
                        <td className="txt-center" >{item.valor}</td>
                    </tr>
                ))}
            </tbody>
        </table>
    )
};

export {TableCober};